const DOCUMENTATION = 'https://pertento.ai/documentation';

/**
 * The public guides a Server-side experiment's Assignment card links to, by what they cover. The
 * titles are the guides' own, so a link reads as the page it opens. The paths are the published
 * slugs on pertento.ai; renaming a guide there breaks the link here.
 */
export const GUIDES = {
  overview: {
    title: 'Running a Server-side experiment',
    href: `${DOCUMENTATION}/running-a-server-side-experiment-with-pertento/`,
  },
  browserCode: {
    title: 'Showing a browser-assigned variant from your own code',
    href: `${DOCUMENTATION}/showing-a-browser-assigned-variant-from-your-own-code/`,
  },
  serverSetup: {
    title: 'Setting up an experiment with Assignment: Server',
    href: `${DOCUMENTATION}/setting-up-an-experiment-with-assignment-server/`,
  },
  visitorId: {
    title: 'Anonymous visitor ID',
    href: `${DOCUMENTATION}/visitor-id/`,
  },
  serverKeys: {
    title: 'Server keys: creating, rotating and revoking',
    href: `${DOCUMENTATION}/server-keys-creating-rotating-and-revoking/`,
  },
  sdk: {
    title: 'Installing the Pertento Server SDK',
    href: `${DOCUMENTATION}/installing-the-pertento-server-sdk/`,
  },
  httpApi: {
    title: 'The Server-side HTTP API: Decide, Events and Config',
    href: `${DOCUMENTATION}/the-server-side-http-api/`,
  },
  rules: {
    title: 'Attribute rules and bucketing on a customer ID',
    href: `${DOCUMENTATION}/attribute-rules-and-bucketing-on-a-customer-id/`,
  },
  conversions: {
    title: 'Reporting conversions from your server',
    href: `${DOCUMENTATION}/reporting-conversions-from-your-server/`,
  },
  troubleshooting: {
    title: "Why isn't my Server-side experiment counting visitors?",
    href: `${DOCUMENTATION}/why-isnt-my-server-side-experiment-counting-visitors/`,
  },
} as const;

export type GuideId = keyof typeof GUIDES;

type Decider = 'browser' | 'server';

/** The guide the card's header links to, for the assignment chosen. */
export const SETUP_GUIDE: Record<Decider, GuideId> = {
  browser: 'overview',
  server: 'serverSetup',
};

/** Linked from the checklist's last step, adding the code: installing the SDK. */
export const CODE_STEP_GUIDE: GuideId = 'sdk';

/** Linked from the browser snippet's heading: how the page's own code shows the variant. */
export const BROWSER_CODE_GUIDE: GuideId = 'browserCode';

/**
 * The foot of a server-assigned card: only the guides nothing above already links. The setup
 * guide is the header's, and the visitor ID, server key and SDK guides are on their checklist
 * steps, so listing them again would be the same link twice.
 */
export const MORE_SERVER_GUIDES: readonly GuideId[] = ['conversions', 'rules', 'httpApi', 'troubleshooting'];
